

import React from "react";
import '../styles/pages.css'; 
import { useTranslation } from 'react-i18next';


function DisclaimerPage(props) {
  const { t } = useTranslation();

const text = []
let reworked = [];
text.map((string) => reworked.push(...string.split(":", 2)));
let noDoubles = [...new Set(reworked)]
// console.log(noDoubles.map(str=> str.trim()));


    return (
      <React.Fragment>
        
         <div className="App" style={{marginTop: "2rem"}}>
        <h5 className="title-body">{t('disclaimer_title')}</h5>
        <br></br>
        <h5 className="title-body-no-bold">{t('disclaimer_general_provisions_title')}</h5>
     <p className="paragraph-body">{t('disclaimer_general_provisions_text1')}</p>
     <p className="paragraph-body">{t('disclaimer_general_provisions_text2')}</p>
     <br></br>
     <h5 className="title-body-no-bold">{t('disclaimer_responsibility_title')}</h5>
     <p className="paragraph-body"> </p>

   
     <p className="paragraph-body">{t('disclaimer_responsibility_text')}</p>
     <br></br>
     <h5 className="title-body-no-bold">{t('disclaimer_privileges_title')}</h5>
     <p className="paragraph-body">{t('disclaimer_privileges_text1')}</p>
     <p className="paragraph-body">{t('disclaimer_privileges_text2')}</p>
     <span><a style={{ color:"#116AAB", fontSize:"14px" , textDecoration: "none"}} href="1https://www.fao.org/contact-us/terms/en/ " target="_blank ">https://www.fao.org/contact-us/terms/{t('language_variable')}/</a></span>

  </div>
      </React.Fragment>
    );
  }

  export default DisclaimerPage;